/**
 * Input-image aspect-ratio limits observed from Runway. Keep in sync with the
 * backend's video-model-limits.ts: 2.358 is the observed ceiling even for
 * Seedance, despite the docs advertising 2.5.
 */
export interface ImageAspectRatioBounds {
  min: number;
  max: number;
}

export const IMAGE_ASPECT_RATIO_BOUNDS: Record<string, ImageAspectRatioBounds> =
  {
    gen4_turbo: { min: 0.5, max: 2.358 },
    'gen4.5': { min: 0.5, max: 2 },
    seedance2: { min: 0.4, max: 2.358 },
    seedance2_5: { min: 0.4, max: 2.358 },
    kling_4: { min: 0.4, max: 2.358 },
  };

/**
 * Conservative range for model-agnostic library uploads. Keeps images usable
 * with the current Gen-4 Turbo and Seedance video models.
 */
export const LIBRARY_IMAGE_ASPECT_BOUNDS: ImageAspectRatioBounds = {
  min: 0.5,
  max: 2.358,
};

export function getImageAspectRatioBounds(
  model: string
): ImageAspectRatioBounds | null {
  return IMAGE_ASPECT_RATIO_BOUNDS[model] ?? null;
}

export function isImageAspectRatioWithinBounds(
  width: number,
  height: number,
  bounds: ImageAspectRatioBounds
): boolean {
  if (
    !Number.isFinite(width) ||
    !Number.isFinite(height) ||
    width <= 0 ||
    height <= 0
  ) {
    return false;
  }
  const ratio = width / height;
  return ratio >= bounds.min && ratio <= bounds.max;
}
